// return string starts from capitalized letter
export const firstSymbolToUpperCase = (s: string) => s.charAt(0).toUpperCase() + s.substring(1);
